export const AM_NODATA = 'Not enough data to generate analysis';
export const AM_NO_DISENGAGED = 'Yay! You don’t have any disengaged employee';
